import { useState } from "react";
import { Button, Stack } from "@mui/material";
import CustomersImportModal from "../components/CustomersImportModal";
import SuppliersImportModal from "../components/SuppliersImportModal";
import MaterialsImportModal from "../components/MaterialsImportModal";
import BomRoutingImportModal from "../components/BomRoutingImportModal";
import SalesOrdersImportModal from "../components/SalesOrdersImportModal";
import ProductionPlanImportModal from "../components/ProductionPlanImportModal";
import InventoryImportModal from "../components/InventoryImportModal";
import VariantsImportModal from "../components/VariantsImportModal";
import ReservationsImportModal from "../components/ReservationsImportModal";
import { PageHeader } from "../components/ui";

const IMPORT_ACTIONS = [
  { key: "customers", label: "Müşteri Aktar" },
  { key: "suppliers", label: "Tedarikçi Aktar" },
  { key: "materials", label: "Malzeme Aktar" },
  { key: "bomRouting", label: "BOM/Rota Aktar" },
  { key: "salesOrders", label: "Sipariş Aktar" },
  { key: "planning", label: "Planlama Aktar" },
  { key: "inventory", label: "Hammadde Aktar" },
  { key: "variants", label: "Varyant Anahtarı Aktar" },
  { key: "reservations", label: "Rezervasyon Aktar" },
];

function currentUserRole() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.role || null;
  } catch {
    return null;
  }
}

export default function SupportExcelImport() {
  const [activeImport, setActiveImport] = useState("");
  const role = currentUserRole();
  // Hammadde Aktar depocu rolüne özel; admin de görür/kullanabilir. Depocu
  // sadece bu butonu görür.
  const visibleActions =
    role === "depocu"
      ? IMPORT_ACTIONS.filter((a) => a.key === "inventory")
      : role === "admin"
        ? IMPORT_ACTIONS
        : IMPORT_ACTIONS.filter((a) => a.key !== "inventory");

  const closeImport = () => setActiveImport("");

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Destek Tabloları / Excel Aktar"
        subtitle="Excel içe aktarma işlemleri."
      />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.25}
        useFlexGap
        flexWrap="wrap"
        sx={{ maxWidth: 760 }}
      >
        {visibleActions.map((action) => (
          <Button
            key={action.key}
            variant="contained"
            onClick={() => setActiveImport(action.key)}
            sx={{
              minWidth: { xs: "100%", sm: 180 },
              justifyContent: "flex-start",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            {action.label}
          </Button>
        ))}
      </Stack>

      {activeImport === "customers" ? <CustomersImportModal onClose={closeImport} /> : null}
      {activeImport === "suppliers" ? <SuppliersImportModal onClose={closeImport} /> : null}
      {activeImport === "materials" ? <MaterialsImportModal onClose={closeImport} /> : null}
      {activeImport === "bomRouting" ? <BomRoutingImportModal onClose={closeImport} /> : null}
      {activeImport === "salesOrders" ? <SalesOrdersImportModal onClose={closeImport} /> : null}
      {activeImport === "planning" ? <ProductionPlanImportModal onClose={closeImport} /> : null}
      {activeImport === "inventory" ? <InventoryImportModal onClose={closeImport} /> : null}
      {activeImport === "variants" ? <VariantsImportModal onClose={closeImport} /> : null}
      {activeImport === "reservations" ? <ReservationsImportModal onClose={closeImport} /> : null}
    </Stack>
  );
}
